
export default {
	name: '肥料B',
	// 产品参数
	overview: {
		// 详细信息
		details: [
			{ label: "产地", value : "Guangdong, China" },
			{ label: "品牌名称", value : "不适用" },
			{ label: "型号", value : "IGS-70" },
			{ label: "塑料类型", value : "ABS+ 亚克力" },
			{ label: "植物纤维类型", value : "/" },
			{ label: "陶瓷类型", value : "/" },
			{ label: "材料", value : "塑料, 金属" },
			{ label: "类型", value : "/" },
			{ label: "表格", value : "/" },
			{ label: "整理", value : "/" },
			{ label: "金属类型", value : "铝" },
			{ label: "使用条件", value : "花园、家居、酒店、商场" },
			{ label: "用于", value : "鱼菜共生" },
			{ label: "纸张尺寸", value : "41*20*32.3 厘米" },
			{ label: "电源", value : "交流/直流" },
			{ label: "用法", value : "植物生长和鱼类养殖" },
			{ label: "智能型", value : "数字、电子、传感器" },
			{ label: "所需电池", value : "不" },
			{ label: "控制模式", value : "触碰" },
			{ label: "应用", value : "办公室、客厅、厨房、室内" },
			{ label: "设计风格", value : "欧洲" },
			{ label: "供应能力", value : "每周 50000 包/包"},
		],
		// 包装
		packaging: [
			{ label: "销售单位", value : "单品"},
			{ label: "单个包装尺寸： "},
			{ label: "42X39X53 厘米"},
			{ label: "单件毛重", value : "3.500 公斤"},
			{ label: "包装类型", value : "中性包装。"},
			{ label: "港口", value : "Shenzhen"},
			{ label: "交货时间", value : "<b>1-5000:</b>15天<br/>	<b>5001-20000:</b>30天<br/><b>20001-50000:</b>35天<br/>	<b>>1000:</b>待协商"},
		],
	},
	// 视频
	videos: {
		// 介绍
		introduction: [
			{ label: "DJI Pocket 2 | 介绍视频", date: "2020-07-08", cover: "https://www1.djicdn.com/cms/uploads/bbb15726362623442902bebca757bb55@770*462.jpg", src: "https://cdn.djivideos.com/watch/89673044-e8ba-4fa3-a58a-a9ce23087467?autoplay=false&poster=https://videocaption.djicdn.com/poster/20201019/d16a55cc894d7ff2c8a84f05734b8bee.png@!1200"},
			{ label: "DJI Pocket 3 | 介绍视频", date: "2020-07-08", cover: "https://www1.djicdn.com/cms/uploads/bbb15726362623442902bebca757bb55@770*462.jpg", src: "https://cdn.djivideos.com/watch/89673044-e8ba-4fa3-a58a-a9ce23087467?autoplay=false&poster=https://videocaption.djicdn.com/poster/20201019/d16a55cc894d7ff2c8a84f05734b8bee.png@!1200"}
		],
		// 教程
		course: [
			{ label: "IGS11 视频介绍", date: "2020-10-20", cover: "https://sc01.alicdn.com/kf/H39eb36fabba14cd1a0d6d9d338a0b712f.jpg", src: "//cloud.video.alibaba.com/play/u/2153292369/p/1/e/6/t/1/d/hd/288872778138.mp4"}
		],
	}
}
